// TODO: refactor
export const currencyMapping = {
  en: 'EUR',
  ru: 'RUB',
};

export function convertErrorsFromDjango(errors) {
  // Transform django errors
  // e.g.
  // {"errors": [{"message": {"phone": ["Please provide a valid phone number in international format, e.g. +33 123 456 7890"]}}]}
  // to formik simple obj errors
  // e.g.
  // {phone: "Error message"}
  return errors.reduce((obj, err) => {
    const { message } = err;
    Object.keys(message).forEach((key) => {
      // eslint-disable-next-line no-param-reassign
      obj[key] = Array.isArray(message[key])
        ? message[key].join(',')
        : message[key];
    });
    return obj;
  }, {});
}
